function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.576 1.077c.238-.09.499-.101.744-.034l.104.034 4.227 1.585a1.208 1.208 0 01.78 1.031l.004.1V7.03a5.436 5.436 0 01-2.844 4.777l-.16.084-2.026 1.013a.906.906 0 01-.723.037l-.087-.037-2.025-1.013a5.434 5.434 0 01-3.002-4.68l-.003-.181V3.793A1.208 1.208 0 012.257 2.7l.092-.04 4.227-1.584zm2.497 3.885L6.297 7.738 5.229 6.671a.604.604 0 10-.854.854l1.452 1.452a.664.664 0 00.94 0l3.16-3.161a.603.603 0 10-.854-.854z",
  fill: "currentColor"
});

var SvgCertified = function SvgCertified(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none"
  }, props), _ref);
};

export default SvgCertified;